import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  body: {
    height: '100%',
    backgroundColor: 'white',
  },
  WidgetLayout: {
    textAlign: 'center',
    padding: 16,
  },
  WidgetLayoutAlign: {
    textAlign: 'left',
    padding: 16,
  },
  contents: {
    display: 'flex',
    padding: 10,
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'Column',
    },
  },
  contentsText: {
    padding: 10,
    [theme.breakpoints.down('xs')]: {
      padding: 1,
    },
  },
  Widget: {
    margin: 'auto',
  },
  img: {
    minWidth: 250,
    maxWidth: 250,
    minHeight: 150,
    maxHeight: 150,
    objectFit: 'contain',
    border: '1px solid black',
  },
  titleText: {
    margin: '0px !important',
  },
}));
